export const TURF_SIMULATOR_TAB = { id: 'turf-simulator', label: 'TURF Simulator' };

export const hasTurfQuestion = (questions = []) => questions.some(({ turf }) => turf === true);

export const canShowResponseQualityTab = ({
  isResponseQualityGateEnabled = false,
  isStatsigLoading = false,
  publicToken,
} = {}) => !publicToken && !isStatsigLoading && isResponseQualityGateEnabled;

export const canShowTurfSimulatorTab = ({
  isStatsigLoading = false,
  isTurfSimulatorGateEnabled = false,
  publicToken,
  surveyQuestions,
} = {}) =>
  !publicToken &&
  !isStatsigLoading &&
  isTurfSimulatorGateEnabled &&
  hasTurfQuestion(surveyQuestions);
